import React from 'react';
import SalesCostListContainer from '../../containers/sales-cost-manage/SalesCostListContainer';

const SalesCostManageListPage = () => {
  return <SalesCostListContainer />;
};

export default SalesCostManageListPage;
